import "./TourLikeButton.scss";

const HEART_PATH =
    "M12 20.5s-7.5-4.6-9.2-9.4C1.6 7.6 3.9 4.5 7.2 4.5c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.3 0 5.6 3.1 4.4 6.6-1.7 4.8-9.2 9.4-9.2 9.4z";

// 버튼 없이 하트 아이콘만 필요할 때 (SubHeader menus.content 처럼 이미 button 안인 자리)
export const TourHeartIcon = ({ liked, size = 24 }) => (
    <span className={`tour-like-icon${liked ? " is-liked" : ""}`}>
        <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
            <path d={HEART_PATH} strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
    </span>
);

/**
 * 투어 찜(하트) 버튼.
 * variant: "overlay" — 카드 이미지 위 (기본)
 */
const TourLikeButton = ({ liked, onClick, variant = "overlay", className = "" }) => {
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick?.(e);
    };

    return (
        <button
            type="button"
            className={`tour-like-btn tour-like-btn--${variant}${liked ? " is-liked" : ""} ${className}`.trim()}
            onClick={handleClick}
            aria-pressed={liked}
            aria-label={liked ? "찜 해제" : "찜하기"}
        >
            <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
                <path
                    d={HEART_PATH}
                    strokeWidth="1.8"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
};

export default TourLikeButton;
